import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  zh: {
    translation: {
      // App Title
      appTitle: 'Fun with AI',
      appSubtitle: '',
      
      // Search & Input
      searchPlaceholder: '请输入具体的地址和餐厅类型，例如新宿 拉面',
      uploadImage: '上传菜品图片',
      searchButton: '寻找餐厅',
      analyzing: '分析中...',
      searching: '搜索中...',
      specificQueryRequired: '请输入具体的地址和餐厅类型，例如新宿 拉面',
      apiSpecificSuggestion: '请输入具体的地址和餐厅类型，例如新宿 拉面，或者您可以尝试使用对话模式获得更多的选择',
      
      // Restaurant Card
      rating: '评分',
      budget: '预算',
      perPerson: '/人',
      viewDetails: '查看详情',
      addReview: '添加评价',
      
      // Budget Levels
      budgetLow: '经济实惠',
      budgetMid: '中等消费',
      budgetHigh: '高档餐厅',
      
      // Cuisines
      cuisineJapanese: '日本料理',
      cuisineRamen: '拉面',
      cuisineSushi: '寿司',
      cuisineIzakaya: '居酒屋',
      cuisineTempura: '天妇罗',
      cuisineYakiniku: '烤肉',
      cuisineKaiseki: '怀石料理',
      
      // Features
      featureCozy: '温馨',
      featureModern: '现代',
      featureTraditional: '传统',
      featureQuiet: '安静',
      featureBusy: '热闹',
      
      // Empty States
      noResults: '未找到餐厅',
      noResultsDesc: '请尝试调整您的搜索条件',
      uploadImageHint: '上传菜品图片以获得更精准的推荐',
      
      // Errors
      errorTitle: '出错了',
      errorAnalyzing: '图片分析失败',
      errorSearching: '搜索失败',
      tryAgain: '重试',
      
      // Recommendations
      recommendedForYou: '为您推荐',
      basedOnYourQuery: '根据您的查询条件',
      popularNow: '当前热门',
      
      // Moods
      moodHappy: '愉快',
      moodRelaxed: '放松',
      moodEnergetic: '充满活力',
      moodRomantic: '浪漫',
      moodCasual: '随意',
      
      // Query History Sidebar
      queryHistoryTitle: '查询历史',
      expand: '展开',
      collapse: '折叠',
      closeSidebar: '关闭侧边栏',
      clearHistory: '清空历史',
      confirmClearHistory: '确定要清空所有历史记录吗？',
      noHistory: '暂无查询历史',
      noSearchHistory: '暂无搜索历史',
      noChatHistory: '暂无对话历史',
      allHistory: '全部',
      searchHistory: '搜索',
      chatHistory: '对话历史',
      startSearchToSaveHistory: '开始搜索以保存历史记录',
      results: '个结果',
      snapshot: '快照',
      snapshotAvailable: '快照可用，点击即可快速加载',
      delete: '删除',
      signInSignUp: '注册/登录',
      user: '用户',
      savedQueriesCount: '已保存 {{count}} 个查询结果',
      signOut: '登出',
      justNow: '刚刚',
      minutesAgo: '{{count}}分钟前',
      hoursAgo: '{{count}}小时前',
      daysAgo: '{{count}}天前',
      newConversation: '新的对话',
      newConversationTooltip: '创建新对话',
      
      // Chat Interface
      searchMode: '搜索',
      chatMode: '对话',
      chatWelcomeTitle: '日本探索AI助手',
      // Version: 1.3.48 - chatWelcomeMessage: '告诉我你想去的地方，我会为你推荐合适的地点',
      chatWelcomeMessage: '懂你想去的，也懂你该去哪。', // Version: 1.3.49
      chatExample1: '新宿有哪些必吃的餐厅',
      chatExample2: '推荐几个北海道滑雪胜地',
      chatExample3: '东京哈利波特主题的景点',
      chatExample4: '附近的咖啡馆推荐',
      chatInputPlaceholder: '告诉我你的需求...',
      chatError: '出错了',
      
      // Limit Modal
      limitModalMessage: '亲！非注册用户最多只能保存5个搜索历史哦～～',
      limitModalSuggestion: '建议您成为注册用户，注册后保存无上限～～',
      limitModalCancel: '取消',
      limitModalRegister: '注册或登录',
      
      // Share Feature
      shareButton: '分享',
      sharing: '分享中...',
      shareTitle: 'Fun with AI 推荐',
      shareError: '分享失败，请稍后重试',
      shareModalTitle: '分享链接',
      shareModalDescription: '复制链接分享给其他人',
      shareModalCopy: '复制',
      shareModalCopied: '已复制',
      shareModalClose: '关闭',
      
      // Update Modal
      updateModalTitle: '功能更新',
      updateModalConfirm: '知道了',
      updateModalLoading: '加载中...',
      updateModalNoUpdates: '暂无更新内容',
      updateModalError: '无法加载更新内容',
      updateModalClose: '关闭',
      
      // Service Intro Modal
      serviceIntroTitle: '服务介绍',
      serviceIntroNext: '下一步',
      serviceIntroLoading: '加载中...',
      serviceIntroNoContent: '暂无介绍内容',
      serviceIntroError: '无法加载服务介绍内容',
      
      // Feedback
      feedback: '意见',

      // 2.0.0: Theme Toggle & Language
      theme: '主题',
      themeLight: '亮色',
      themeDark: '暗色',
      themeSystem: '跟随系统',
      themeToggleToDark: '切换到暗色模式',
      themeToggleToSystem: '切换到跟随系统',
      themeToggleToLight: '切换到亮色模式',
      language: '语言',
      switchLanguage: '切换语言',

      // 2.0.0: Welcome Screen
      welcomeTitle: '欢迎来到日本探索AI助手',
      welcomeFeatureFood: '当地美食',
      welcomeFeatureNearby: '附近搜索',
      welcomeFeatureMood: '描述心情',

      // 2.0.0: Preferences UI
      preferencesTitle: '用户偏好',
      preferencesDesc: '基于您的对话记录，AI 已为您提取以下偏好。您也可以手动添加或编辑。',
      prefTypePreference: '偏好',
      prefTypeRestriction: '限制',
      prefTypeFact: '事实',
      prefSourceAI: 'AI 提取',
      prefSourceManual: '手动添加',
      prefAdd: '添加偏好',
      prefAddPlaceholder: '输入新的偏好...',
      prefEmpty: '暂无偏好记录',
      prefEmptyHint: '开始与 AI 对话，系统会自动记录您的偏好',
      prefLoadError: '加载偏好失败',

      // Favorites (Version: 1.2.15)
      favorites: '已收藏的餐厅',
      favoritesGalleryTitle: '收藏美食地图',
      favoriteCount: '已收藏 {{count}} 个餐厅',
      addToFavorites: '添加到收藏',
      removeFromFavorites: '取消收藏',
      noFavorites: '暂无收藏的餐厅',
      noFavoritesDescription: '开始收藏您喜欢的餐厅吧！',
      loginToFavorite: '登录后即可收藏餐厅',
      processingFavorites: '正在处理收藏的餐厅...',
      
      // My Page (Version: 1.2.8)
      myPageTitle: 'Modern <highlight>AI</highlight> Traveler Profile',
      personalInfo: '个人信息',
      myPage: '我的页面',
      myProfile: '我的资料',
      userAvatar: '用户头像',
      uploadAvatar: '上传头像',
      changeAvatar: '更换头像',
      userName: '用户名称',
      userEmail: '用户邮箱',
      displayName: '用户名',
      editName: '编辑名称',
      saveName: '保存名称',
      changePassword: '修改密码',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      updatePassword: '更新密码',
      forgotPassword: '忘记密码',
      forgotPasswordConfirm: '确定要发送密码重置链接到您的邮箱吗？',
      sendResetLink: '发送重置链接',
      save: '保存',
      cancel: '取消',
      back: '返回',
      loading: '加载中...',
      success: '成功',
      error: '错误',
      passwordUpdated: '密码修改成功',
      passwordUpdateFailed: '密码修改失败',
      nameUpdated: '名称修改成功',
      nameUpdateFailed: '名称修改失败',
      avatarUploaded: '头像上传成功',
      avatarUploadFailed: '头像上传失败',
      resetLinkSent: '密码重置链接已发送到您的邮箱',
      resetLinkSentLocal: '密码重置链接已发送！本地环境请查看 Inbucket 邮箱收件箱',
      resetLinkFailed: '发送密码重置链接失败',
      passwordMismatch: '新密码和确认密码不一致',
      passwordTooShort: '密码长度至少6个字符',
      loginMethod: '登录方式',
      currentLoginMethod: '当前登录方式',
      ssoLoginInfo: '使用第三方账号登录',
      ssoLoginDescription: '您使用第三方账号（如 Google）登录，密码由该服务提供商管理。如需修改密码，请在对应的服务提供商处进行修改。',
      invalidImageFormat: '不支持的图片格式',
      imageTooLarge: '图片大小不能超过5MB',
    }
  },
  ja: {
    translation: {
      // App Title
      appTitle: 'Fun with AI',
      appSubtitle: '',
      
      // Search & Input
      searchPlaceholder: '具体的な住所とレストランタイプを入力してください（例：新宿 ラーメン）',
      uploadImage: '料理の写真をアップロード',
      searchButton: 'レストランを探す',
      analyzing: '分析中...',
      searching: '検索中...',
      specificQueryRequired: '具体的な住所とレストランタイプを入力してください（例：新宿 ラーメン）',
      apiSpecificSuggestion: '具体的な住所とレストランタイプを入力するか、チャットモードでおすすめを試してみてください（例：新宿 ラーメン）',
      
      // Restaurant Card
      rating: '評価',
      budget: '予算',
      perPerson: '/人',
      viewDetails: '詳細を見る',
      addReview: 'レビューを追加',
      
      // Budget Levels
      budgetLow: 'お手頃',
      budgetMid: '普通',
      budgetHigh: '高級',
      
      // Cuisines
      cuisineJapanese: '日本料理',
      cuisineRamen: 'ラーメン',
      cuisineSushi: '寿司',
      cuisineIzakaya: '居酒屋',
      cuisineTempura: '天ぷら',
      cuisineYakiniku: '焼肉',
      cuisineKaiseki: '懐石料理',
      
      // Features
      featureCozy: '居心地が良い',
      featureModern: 'モダン',
      featureTraditional: '伝統的',
      featureQuiet: '静か',
      featureBusy: '賑やか',
      
      // Empty States
      noResults: 'レストランが見つかりません',
      noResultsDesc: '検索条件を調整してください',
      uploadImageHint: '料理の写真をアップロードして、より正確な推薦を受けましょう',
      
      // Errors
      errorTitle: 'エラーが発生しました',
      errorAnalyzing: '画像分析に失敗しました',
      errorSearching: '検索に失敗しました',
      tryAgain: '再試行',
      
      // Recommendations
      recommendedForYou: 'おすすめ',
      basedOnYourQuery: 'あなたの検索条件に基づいて',
      popularNow: '人気',
      
      // Moods
      moodHappy: '楽しい',
      moodRelaxed: 'リラックス',
      moodEnergetic: '元気',
      moodRomantic: 'ロマンチック',
      moodCasual: 'カジュアル',
      
      // Query History Sidebar
      queryHistoryTitle: '検索履歴',
      expand: '展開',
      collapse: '折りたたむ',
      closeSidebar: 'サイドバーを閉じる',
      clearHistory: '履歴をクリア',
      confirmClearHistory: 'すべての履歴をクリアしてもよろしいですか？',
      noHistory: '検索履歴がありません',
      noSearchHistory: '検索履歴がありません',
      noChatHistory: 'チャット履歴がありません',
      allHistory: 'すべて',
      searchHistory: '検索',
      chatHistory: 'チャット履歴',
      startSearchToSaveHistory: '検索を開始して履歴を保存',
      results: '件の結果',
      snapshot: 'スナップショット',
      snapshotAvailable: 'スナップショットが利用可能です。クリックしてすぐに読み込みます',
      delete: '削除',
      signInSignUp: '登録/ログイン',
      user: 'ユーザー',
      savedQueriesCount: '{{count}}件の検索結果を保存しました',
      signOut: 'ログアウト',
      justNow: 'たった今',
      minutesAgo: '{{count}}分前',
      hoursAgo: '{{count}}時間前',
      daysAgo: '{{count}}日前',
      newConversation: '新しい会話',
      newConversationTooltip: '新しい会話を作成',
      
      // Chat Interface
      searchMode: '検索',
      chatMode: 'チャット',
      chatWelcomeTitle: '日本探索AIアシスタント',
      // Version: 1.3.48 - chatWelcomeMessage: '行きたい場所を教えてください。適切な場所をおすすめします',
      chatWelcomeMessage: '行きたい場所も、行くべき場所も、わかります。', // Version: 1.3.49
      chatExample1: '新宿で必ず食べるべきレストラン',
      chatExample2: '北海道のスキーリゾートをいくつかおすすめ',
      chatExample3: '東京のハリー・ポッターテーマの観光スポット',
      chatExample4: '近くのおすすめカフェ',
      chatInputPlaceholder: 'あなたのニーズを教えてください...',
      chatError: 'エラーが発生しました',
      
      // Limit Modal
      limitModalMessage: '親！未登録ユーザーは最大5つの検索履歴しか保存できません～～',
      limitModalSuggestion: '登録ユーザーになることをお勧めします。登録後は保存数に上限がありません～～',
      limitModalCancel: 'キャンセル',
      limitModalRegister: '登録またはログイン',
      
      // Share Feature
      shareButton: 'シェア',
      sharing: 'シェア中...',
      shareTitle: 'Fun with AI おすすめ',
      shareError: 'シェアに失敗しました。後でもう一度お試しください',
      shareModalTitle: 'シェアリンク',
      shareModalDescription: 'リンクをコピーして他の人とシェア',
      shareModalCopy: 'コピー',
      shareModalCopied: 'コピーしました',
      shareModalClose: '閉じる',
      
      // Update Modal
      updateModalTitle: '機能更新',
      updateModalConfirm: '了解しました',
      updateModalLoading: '読み込み中...',
      updateModalNoUpdates: '更新内容がありません',
      updateModalError: '更新内容を読み込めません',
      updateModalClose: '閉じる',
      
      // Service Intro Modal
      serviceIntroTitle: 'サービス紹介',
      serviceIntroNext: '次へ',
      serviceIntroLoading: '読み込み中...',
      serviceIntroNoContent: '紹介内容がありません',
      serviceIntroError: 'サービス紹介内容を読み込めません',
      
      // Feedback
      feedback: 'ご意見',

      // 2.0.0: Theme Toggle & Language
      theme: 'テーマ',
      themeLight: 'ライト',
      themeDark: 'ダーク',
      themeSystem: 'システムに従う',
      themeToggleToDark: 'ダークモードに切替',
      themeToggleToSystem: 'システム設定に切替',
      themeToggleToLight: 'ライトモードに切替',
      switchLanguage: '言語切替',

      // 2.0.0: Welcome Screen
      welcomeTitle: '日本探索AIアシスタントへようこそ',
      welcomeFeatureFood: 'ご当地グルメ',
      welcomeFeatureNearby: '近くを検索',
      welcomeFeatureMood: '気分で探す',

      // 2.0.0: Preferences UI
      preferencesTitle: 'ユーザー設定',
      preferencesDesc: '会話履歴から AI があなたの好みを抽出しました。手動で追加・編集も可能です。',
      prefTypePreference: '好み',
      prefTypeRestriction: '制限',
      prefTypeFact: '情報',
      prefSourceAI: 'AI 抽出',
      prefSourceManual: '手動追加',
      prefAdd: '好みを追加',
      prefAddPlaceholder: '新しい好みを入力...',
      prefEmpty: '好みの記録がありません',
      prefEmptyHint: 'AIとの会話を始めると、自動的に好みが記録されます',
      prefLoadError: '好みの読み込みに失敗しました',

      // Favorites (Version: 1.2.15)
      favorites: 'お気に入りのレストラン',
      favoritesGalleryTitle: 'お気に入りグルメギャラリー',
      favoriteCount: '{{count}}件のお気に入りレストラン',
      addToFavorites: 'お気に入りに追加',
      removeFromFavorites: 'お気に入りから削除',
      noFavorites: 'お気に入りのレストランがありません',
      noFavoritesDescription: 'お気に入りのレストランを追加しましょう！',
      loginToFavorite: 'ログイン後にお気に入りに追加できます',
      processingFavorites: 'お気に入りを処理中...',
      
      // My Page (Version: 1.2.8)
      myPageTitle: 'Modern <highlight>AI</highlight> Traveler Profile',
      personalInfo: '個人情報',
      myPage: 'マイページ',
      myProfile: 'マイプロフィール',
      userAvatar: 'ユーザーアバター',
      uploadAvatar: 'アバターをアップロード',
      changeAvatar: 'アバターを変更',
      userName: 'ユーザー名',
      userEmail: 'ユーザーメール',
      displayName: 'ユーザー名',
      editName: '名前を編集',
      saveName: '名前を保存',
      changePassword: 'パスワードを変更',
      oldPassword: '旧パスワード',
      newPassword: '新パスワード',
      confirmPassword: 'パスワード確認',
      updatePassword: 'パスワードを更新',
      forgotPassword: 'パスワードを忘れた',
      forgotPasswordConfirm: 'パスワードリセットリンクをメールに送信しますか？',
      sendResetLink: 'リセットリンクを送信',
      save: '保存',
      cancel: 'キャンセル',
      back: '戻る',
      loading: '読み込み中...',
      success: '成功',
      error: 'エラー',
      passwordUpdated: 'パスワードが正常に変更されました',
      passwordUpdateFailed: 'パスワードの変更に失敗しました',
      nameUpdated: '名前が正常に変更されました',
      nameUpdateFailed: '名前の変更に失敗しました',
      avatarUploaded: 'アバターが正常にアップロードされました',
      avatarUploadFailed: 'アバターのアップロードに失敗しました',
      resetLinkSent: 'パスワードリセットリンクがメールに送信されました',
      resetLinkSentLocal: 'パスワードリセットリンクが送信されました！ローカル環境では Inbucket の受信トレイを確認してください',
      loginMethod: 'ログイン方法',
      currentLoginMethod: '現在のログイン方法',
      ssoLoginInfo: 'サードパーティアカウントでログイン',
      ssoLoginDescription: 'サードパーティアカウント（Google など）でログインしています。パスワードはそのサービスプロバイダーによって管理されています。パスワードを変更する場合は、対応するサービスプロバイダーで変更してください。',
      resetLinkFailed: 'パスワードリセットリンクの送信に失敗しました',
      passwordMismatch: '新パスワードと確認パスワードが一致しません',
      passwordTooShort: 'パスワードは少なくとも6文字である必要があります',
      invalidImageFormat: 'サポートされていない画像形式です',
      imageTooLarge: '画像サイズは5MBを超えることはできません',
    }
  },
  en: {
    translation: {
      // App Title
      appTitle: 'Fun with AI',
      appSubtitle: '',
      
      // Search & Input
      searchPlaceholder: 'Enter a specific address and restaurant type, e.g., Shinjuku ramen',
      uploadImage: 'Upload food image',
      searchButton: 'Find Restaurants',
      analyzing: 'Analyzing...',
      searching: 'Searching...',
      specificQueryRequired: 'Please enter a specific address and restaurant type, e.g., Shinjuku ramen',
      apiSpecificSuggestion: 'Enter a specific address and restaurant type (e.g., Shinjuku ramen) or try Chat Mode for more options',
      
      // Restaurant Card
      rating: 'Rating',
      budget: 'Budget',
      perPerson: '/person',
      viewDetails: 'View Details',
      addReview: 'Add Review',
      
      // Budget Levels
      budgetLow: 'Affordable',
      budgetMid: 'Moderate',
      budgetHigh: 'Upscale',
      
      // Cuisines
      cuisineJapanese: 'Japanese',
      cuisineRamen: 'Ramen',
      cuisineSushi: 'Sushi',
      cuisineIzakaya: 'Izakaya',
      cuisineTempura: 'Tempura',
      cuisineYakiniku: 'Yakiniku',
      cuisineKaiseki: 'Kaiseki',
      
      // Features
      featureCozy: 'Cozy',
      featureModern: 'Modern',
      featureTraditional: 'Traditional',
      featureQuiet: 'Quiet',
      featureBusy: 'Lively',
      
      // Empty States
      noResults: 'No restaurants found',
      noResultsDesc: 'Try adjusting your search criteria',
      uploadImageHint: 'Upload a food image for more accurate recommendations',
      
      // Errors
      errorTitle: 'Something went wrong',
      errorAnalyzing: 'Image analysis failed',
      errorSearching: 'Search failed',
      tryAgain: 'Try again',
      
      // Recommendations
      recommendedForYou: 'Recommended for You',
      basedOnYourQuery: 'Based on your query',
      popularNow: 'Popular Now',
      
      // Moods
      moodHappy: 'Happy',
      moodRelaxed: 'Relaxed',
      moodEnergetic: 'Energetic',
      moodRomantic: 'Romantic',
      moodCasual: 'Casual',
      
      // Query History Sidebar
      queryHistoryTitle: 'Query History',
      expand: 'Expand',
      collapse: 'Collapse',
      closeSidebar: 'Close Sidebar',
      clearHistory: 'Clear History',
      confirmClearHistory: 'Are you sure you want to clear all history?',
      noHistory: 'No query history',
      noSearchHistory: 'No search history',
      noChatHistory: 'No chat history',
      allHistory: 'All',
      searchHistory: 'Search',
      chatHistory: 'Chat History',
      startSearchToSaveHistory: 'Start searching to save history',
      results: 'results',
      snapshot: 'Snapshot',
      snapshotAvailable: 'Snapshot available, click to load quickly',
      delete: 'Delete',
      signInSignUp: 'Sign In/Up',
      user: 'User',
      savedQueriesCount: 'Saved {{count}} query results',
      signOut: 'Sign Out',
      justNow: 'Just now',
      minutesAgo: '{{count}} minutes ago',
      hoursAgo: '{{count}} hours ago',
      daysAgo: '{{count}} days ago',
      newConversation: 'New Conversation',
      newConversationTooltip: 'Create new conversation',
      
      // Chat Interface
      searchMode: 'Search',
      chatMode: 'Chat',
      chatWelcomeTitle: 'Japan Explorer AI Assistant',
      // Version: 1.3.48 - chatWelcomeMessage: 'Tell me where you want to go, and I will recommend suitable places',
      chatWelcomeMessage: 'We understand where you want to go, and where you should go.', // Version: 1.3.49
      chatExample1: 'Must-try restaurants in Shinjuku',
      chatExample2: 'Recommend some Hokkaido ski resorts',
      chatExample3: 'Harry Potter themed attractions in Tokyo',
      chatExample4: 'Nearby cafe recommendations',
      chatInputPlaceholder: 'Tell me your needs...',
      chatError: 'Error occurred',
      
      // Limit Modal
      limitModalMessage: 'Hey! Unregistered users can only save up to 5 search history items～～',
      limitModalSuggestion: 'We recommend becoming a registered user. After registration, there is no limit to saving～～',
      limitModalCancel: 'Cancel',
      limitModalRegister: 'Register or Login',
      
      // Share Feature
      shareButton: 'Share',
      sharing: 'Sharing...',
      shareTitle: 'Fun with AI Recommendation',
      shareError: 'Share failed, please try again later',
      shareModalTitle: 'Share Link',
      shareModalDescription: 'Copy link to share with others',
      shareModalCopy: 'Copy',
      shareModalCopied: 'Copied',
      shareModalClose: 'Close',
      
      // Update Modal
      updateModalTitle: 'Feature Updates',
      updateModalConfirm: 'Got it',
      updateModalLoading: 'Loading...',
      updateModalNoUpdates: 'No updates available',
      updateModalError: 'Failed to load update content',
      updateModalClose: 'Close',
      
      // Service Intro Modal
      serviceIntroTitle: 'Service Introduction',
      serviceIntroNext: 'Next',
      serviceIntroLoading: 'Loading...',
      serviceIntroNoContent: 'No introduction content available',
      serviceIntroError: 'Failed to load service introduction content',
      
      // Feedback
      feedback: 'Feedback',

      // 2.0.0: Theme Toggle & Language
      theme: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeSystem: 'System',
      themeToggleToDark: 'Switch to Dark Mode',
      themeToggleToSystem: 'Switch to System',
      themeToggleToLight: 'Switch to Light Mode',
      switchLanguage: 'Switch Language',

      // 2.0.0: Welcome Screen
      welcomeTitle: 'Welcome to Japan Explorer AI Assistant',
      welcomeFeatureFood: 'Local Delicacies',
      welcomeFeatureNearby: 'Nearby Search',
      welcomeFeatureMood: 'Describe Mood',

      // 2.0.0: Preferences UI
      preferencesTitle: 'User Preferences',
      preferencesDesc: 'AI has extracted your preferences from conversations. You can also add or edit manually.',
      prefTypePreference: 'Preference',
      prefTypeRestriction: 'Restriction',
      prefTypeFact: 'Fact',
      prefSourceAI: 'AI Extracted',
      prefSourceManual: 'Manual',
      prefAdd: 'Add Preference',
      prefAddPlaceholder: 'Enter a new preference...',
      prefEmpty: 'No preferences yet',
      prefEmptyHint: 'Start chatting with AI and your preferences will be recorded automatically',
      prefLoadError: 'Failed to load preferences',

      // Favorites (Version: 1.2.15)
      favorites: 'Favorite Restaurants',
      favoritesGalleryTitle: 'Saved Culinary Destinations Gallery',
      favoriteCount: '{{count}} favorite restaurants',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
      noFavorites: 'No favorite restaurants',
      noFavoritesDescription: 'Start adding your favorite restaurants!',
      loginToFavorite: 'Login to add favorites',
      processingFavorites: 'Processing favorites...',
      
      // My Page (Version: 1.2.8)
      myPageTitle: 'Modern <highlight>AI</highlight> Traveler Profile',
      personalInfo: 'Personal Information',
      myPage: 'My Page',
      myProfile: 'My Profile',
      userAvatar: 'User Avatar',
      uploadAvatar: 'Upload Avatar',
      changeAvatar: 'Change Avatar',
      userName: 'User Name',
      userEmail: 'User Email',
      displayName: 'Username',
      editName: 'Edit Name',
      saveName: 'Save Name',
      changePassword: 'Change Password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      updatePassword: 'Update Password',
      forgotPassword: 'Forgot Password',
      forgotPasswordConfirm: 'Are you sure you want to send a password reset link to your email?',
      sendResetLink: 'Send Reset Link',
      save: 'Save',
      cancel: 'Cancel',
      back: 'Back',
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      passwordUpdated: 'Password updated successfully',
      passwordUpdateFailed: 'Failed to update password',
      nameUpdated: 'Name updated successfully',
      nameUpdateFailed: 'Failed to update name',
      avatarUploaded: 'Avatar uploaded successfully',
      avatarUploadFailed: 'Failed to upload avatar',
      resetLinkSent: 'Password reset link has been sent to your email',
      resetLinkSentLocal: 'Password reset link sent! For local environment, check Inbucket inbox',
      resetLinkFailed: 'Failed to send password reset link',
      passwordMismatch: 'New password and confirm password do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      loginMethod: 'Login Method',
      currentLoginMethod: 'Current Login Method',
      ssoLoginInfo: 'Third-party Account Login',
      ssoLoginDescription: 'You are logged in with a third-party account (e.g., Google). Your password is managed by that service provider. To change your password, please do so at the corresponding service provider.',
      invalidImageFormat: 'Unsupported image format',
      imageTooLarge: 'Image size cannot exceed 5MB',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['zh', 'ja', 'en'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      checkWhitelist: true,
    }
  });

export default i18n;
